import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://quotebid-backend-production.up.railway.app/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setSuccess(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      setError('Failed to send message. Please try emailing us directly at support@quotebid.io');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <h1>✅ Message Sent!</h1>
          <p style={styles.successText}>
            Thank you for contacting us. We'll get back to you within 24-48 hours.
          </p>
          <button onClick={() => setSuccess(false)} style={styles.button}>
            Send Another Message
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1>📬 Contact Us</h1>
        <p style={styles.subtitle}>
          Have a question or feedback? We'd love to hear from you!
        </p>

        {error && <p style={styles.error}>{error}</p>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label>Your Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={styles.input}
              placeholder="John Doe"
            />
          </div>

          <div style={styles.field}>
            <label>Email Address *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
              placeholder="you@example.com"
            />
          </div>

          <div style={styles.field}>
            <label>Subject *</label>
            <select
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              style={styles.input}
            >
              <option value="">Select a topic...</option>
              <option value="General Inquiry">General Inquiry</option>
              <option value="Customer Support">Customer Support</option>
              <option value="Business Support">Business Support</option>
              <option value="Billing Question">Billing Question</option>
              <option value="Bug Report">Bug Report</option>
              <option value="Feature Request">Feature Request</option>
              <option value="Partnership">Partnership Opportunity</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div style={styles.field}>
            <label>Message *</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              style={styles.textarea}
              placeholder="How can we help you?"
              rows={6}
            />
          </div>

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>

        <div style={styles.altContact}>
          <h3>Other Ways to Reach Us</h3>
          <p>
            <strong>Email:</strong> support@quotebid.io<br />
            <strong>Address:</strong> 33310 Beverly Dr, Denham Springs, LA 70706
          </p>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: '40px 20px',
    maxWidth: '600px',
    margin: '0 auto',
  },
  content: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  subtitle: {
    color: '#7f8c8d',
    marginBottom: '30px',
  },
  form: {
    marginBottom: '30px',
  },
  field: {
    marginBottom: '20px',
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    marginTop: '5px',
    boxSizing: 'border-box' as const,
  },
  textarea: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    marginTop: '5px',
    boxSizing: 'border-box' as const,
    resize: 'vertical' as const,
  },
  button: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
  },
  error: {
    color: '#e74c3c',
    backgroundColor: '#fdeaea',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '20px',
  },
  successText: {
    color: '#27ae60',
    fontSize: '18px',
    marginBottom: '20px',
  },
  altContact: {
    borderTop: '1px solid #eee',
    paddingTop: '20px',
    color: '#7f8c8d',
  },
};

export default Contact;